/******************************************************************************************
 *	Yes-No Modal
 ******************************************************************************************/
(function() {
  

  angular
    .module('rcControllers.yesNoModal', [])
    .constant('YES_NO_MODAL_TYPES', {
      ERROR: 'error',
      NOTICE: 'notice',
      SUCCESS: 'success',
      HELP: 'help',
      INFO: 'info'
    })
    .factory(
      'YesNoModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/yes-no-modal.html',
          controller: 'YesNoModalController',
          classNames: 'yes-no-modal'
        });
      }
    )
    .controller(
      'YesNoModalController',
      /* @ngInject */
      function($scope, YesNoModal) {
        //Set modal type
        if ($scope.type) {
          YesNoModal.setType($scope.type);
        }

        //Clicked on yes-button
        $scope.yes = function() {
          YesNoModal.remove({cancelled: false});
        };

        //Clicked on no-button
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          YesNoModal.remove({cancelled: true});
        };
        //For consistency with other modal controllers, the `removeModal()` was kept and the `no()` method is just an alias for it
        $scope.no = $scope.removeModal;
      }
    );
})();
